export const PERSIST_KEYS = {
  USE_CASE: 'use_case',
  ACCOUNTS_IDS: 'accounts_ids',
  AUTH_SIGNAL: 'auth_signal',
};
